import { useState } from 'react';
import { VideoModal } from './VideoModal';

export interface VideoButtonProps {
  videoUrl: string;
  /** Подпись на карточке. Default «Видеоинструкция». */
  label?: string;
}

/**
 * Карточка-кнопка «Видеоинструкция» — первый элемент контента на entry-экранах
 * функций (CLAUDE.md §16.4 / PRD §16.4 / B-008).
 *
 * v0.4.1 (H2.3): canonical «VideoInstructionCard» per Aibek H2.3 brief.
 * Визуально: white bg (`bg-card`) + 2px solid accent border + small yellow
 * circle (`bg-cta` = sunshine yellow #FFCC00) с YouTube-стиль play arrow +
 * black label text ink (#000000 since v0.4.2). Featured filled подход H2.2 (filled accent
 * bg на Home id=1) отменён — карточка теперь визуально идентична с другими
 * карточками + visual distinction через yellow icon, а не bg.
 *
 * Клик открывает модальный плеер `VideoModal`. Design-system стиль совпадает
 * с прочими карточками-кнопками (Header / KindButton).
 */
export function VideoButton({ videoUrl, label = 'Видеоинструкция' }: VideoButtonProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        aria-label="Открыть видеоинструкцию"
        className={
          'w-full flex items-center gap-3 min-h-tap-chip rounded-xl bg-card ' +
          'border-2 border-accent shadow-card text-ink ' +
          'px-4 py-3 focus-visible:ring-2 focus-visible:ring-cta focus-visible:outline-none active:opacity-90'
        }
      >
        <span
          aria-hidden="true"
          className="flex-shrink-0 w-10 h-10 rounded-full bg-cta text-ink flex items-center justify-center"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M8 5v14l11-7z" />
          </svg>
        </span>
        <span className="font-display text-h2 text-left">{label}</span>
      </button>
      {open ? <VideoModal videoUrl={videoUrl} onClose={() => setOpen(false)} /> : null}
    </>
  );
}
